import { render, staticRenderFns } from "./MobileSoundlab.vue?vue&type=template&id=492bcc16&scoped=true"
import script from "./MobileSoundlab.vue?vue&type=script&lang=js"
export * from "./MobileSoundlab.vue?vue&type=script&lang=js"
import style0 from "./MobileSoundlab.vue?vue&type=style&index=0&id=492bcc16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492bcc16",
  null
  
)

export default component.exports